import React, { useState } from 'react'
import {
  Button,
  Table,
  Spinner,
} from 'reactstrap'
import { FaPencilAlt, FaSave, FaTrash } from 'react-icons/fa'

// @Componentes
import { ModalCreditarPregunta } from 'components/ModalCreditarPregunta/ModalCreditarPregunta'
import BuscadorTablas from 'components/Buscador/BuscadorTabla'
import TarjetaContenido from 'components/TarjetaContenido/TarjetaContenido'
import PaginaPorDefecto from './Default'

// @hooks
import { usePregunta } from 'hooks/usePregunta'
import { useToggle } from 'hooks/useToggle'

const initialValues = {
  caracteristica: '',
  grupo_interes: [],
  identificador: '',
  enunciado: '',
}

export default function GestionarPreguntas() {
  /**
   * Estado
   */
  const [buscar, setBuscar] = useState('')
  const { open, onToggle } = useToggle()
  const [preguntaSeleccionada, setProgramaSeleccionada] = useState(initialValues)

  /**
   * Consultas
   */
  const {
    handleBuscarPregunta,
    handleEliminarPregunta,
    obtenerPreguntas,
  } = usePregunta()
  const { data: preguntas, refetch: recargarPreguntas } = obtenerPreguntas(buscar)

  /**
   * Manejadores
   */
  const onClosedModal = () => {
    setProgramaSeleccionada(initialValues)
    recargarPreguntas()
  }

  return (
    <PaginaPorDefecto titulo='Preguntas'>
      <ModalCreditarPregunta
        onToggle={onToggle}
        open={open}
        pregunta={preguntaSeleccionada}
        onClosedModal={onClosedModal}
      />
      <TarjetaContenido
        titulo={<span>Listado de preguntas { !preguntas && <Spinner color='primary' style={{ marginLeft: '1rem' }} />}</span>}
        component={
          <Button outline color='primary' onClick={onToggle}>
            <FaSave />
          </Button>
        }
      >
        <BuscadorTablas
          valor={buscar}
          onChange={setBuscar}
          onBuscar={handleBuscarPregunta}
        />
        <Table responsive>
            <thead>
              <tr>
                <th>Identificador</th>
                <th>Caracteristica</th>
                <th>Grupos de interes</th>
                <th>Enunciado</th>
                <th>Acciones</th>
              </tr>
            </thead>
          <tbody>
            {preguntas?.results?.length === 0 && (
              <tr>
                <td colSpan={7}>
                  <p className='text-center'>No hay preguntas registradas</p>
                </td>
              </tr>
            )}
            {preguntas?.results?.map((pregunta, key) => {
              const manejadorEditarPregunta = () => {
                setProgramaSeleccionada(pregunta)
                onToggle()
              }

              const manejadorEliminarPregunta = () => {
                handleEliminarPregunta(pregunta)
              }

              return (
              <tr key={key}>
                <td>{pregunta.identificador}</td>
                <td>{pregunta.caracteristica__nombre}</td>
                <td>{pregunta.grupos_interes?.map(({nombre})=>nombre).join(', ')}</td>
                <td>{pregunta.enunciado}</td>
                <td className='d-flex'>
                  <Button
                    outline
                    color='primary'
                    size='sm'
                    className='mr-1'
                    onClick={manejadorEditarPregunta}
                  >
                    <FaPencilAlt />
                  </Button>
                  <Button
                    outline
                    color='danger'
                    size='sm'
                    onClick={manejadorEliminarPregunta}
                  >
                    <FaTrash />
                  </Button>
                </td>
              </tr>
            )})}
          </tbody>
        </Table>

      </TarjetaContenido>
    </PaginaPorDefecto>
  )
}
